import React, {Component} from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Copyright from '../common/Copyright';
const moment = require('moment');

export default class Maintenance extends Component {
    constructor() {
        super();
        this.params = new URLSearchParams(window.location.search);
        this.state = {
            message: '',
        };
    }

    static get getMessage() {
        return 'Проводятся технические работы до ';
    }

    setDefaultMessage(maintenance) {
        this.setState({
            message: Maintenance.getMessage+maintenance
        });
    }

    componentDidMount() {
        let maintenance = this.params.get('maintenance');
        maintenance = !!maintenance ? maintenance : moment().add(15, 'minutes').format("DD.MM.YYYY HH:mm");
        this.setDefaultMessage(maintenance);
    }

    render() {
        return (
            <Container maxWidth="sm">
                <Box my={4}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        {this.state.message}
                    </Typography>
                    <Copyright/>
                </Box>
            </Container>
        );
    }
}
